import * as React from "react";
import {useEffect, useRef, useState} from "react";
import type {ActionItem} from "./list_actions_model";
import type {CommonResultsPanelProps} from "../results_panel";

import ActionItemsRenderer from "./action_items_renderer";
import ResultsPanel from "../results_panel";

interface ListOfActionsProps extends CommonResultsPanelProps {
    items: ActionItem[];

    /**
     * Array of current filter words, space-separated
     */
    filterTerms: string[];

    /**
     * Text regarding number of selected items
     */
    selectionText: string;

    /**
     * Index of item which should be selected
     */
    selectedIndex: number;

    updateHeightCallback: () => void;
}

const MORE_ID = 'moreSeparatorId';
enum MoreItemsState {
    HIDDEN,
    SHOWING,
    SHOWN
}

// Component to render the list of actions
export default (props: ListOfActionsProps) => {
    // maxkir.warn("items rendered: ", props.items)

    const [moreItemsState, setMoreItemsState] = useState(MoreItemsState.HIDDEN);

    var actionItemsRenderer = new ActionItemsRenderer(
        props.items, props.selectedIndex, moreItemsState, props.filterTerms);

    const doOpenItem = (elementId: string, e: Event) => {

        if (elementId === MORE_ID) {
            if (moreItemsState === MoreItemsState.HIDDEN) {
                setMoreItemsState(MoreItemsState.SHOWING);
                setTimeout(() => {
                    setMoreItemsState(MoreItemsState.SHOWN);
                    props.updateHeightCallback();
                }, 300);
            }
            return;
        }

        const node = document.getElementById(elementId);
        var command_id = node.getAttribute('data-list-id');
        var command_tag = node.getAttribute('data-list-tag');
        if (command_id) {
            var command = cv_commands.can_run(command_id, command_tag);
            if (command) {
                props.onBeforeItemOpen(true);
                command.run();
            }
        }
    };

    const footerRenderer = () => {
        return <div className="searchEverywhere__footer">
            <span className="searchEverywhere__selectedItems">{props.selectionText}</span>
            <span>apply command <kbd>⏎</kbd></span>
        </div>
    };


    var myContainer = useRef(null);

    useEffect(() => {
        // Part of animation when 'more' item is selected
        if (moreItemsState === MoreItemsState.SHOWING) {
            maxkir.smoothScrollBy(70, myContainer.current, 300);
        }
    }, [moreItemsState, myContainer])

    return <ResultsPanel
        itemsRenderer={actionItemsRenderer}
        doOpenItem={doOpenItem}
        footerRenderer={footerRenderer}
        {...props}
    />
}
